var _require = require('crypto'),
    randomBytes = _require.randomBytes;

var _require2 = require('../help/key_object'),
    createSecretKey = _require2.createSecretKey;

var _require3 = require('../registry'),
    KEYLENGTHS = _require3.KEYLENGTHS;

var Key = require('../jwk/key/oct');

module.exports = function (alg) {
  var keyLength = KEYLENGTHS.get(alg);

  if (!keyLength) {
    return new Key({
      type: 'secret'
    });
  }

  return new Key(createSecretKey(randomBytes(keyLength / 8)), {
    use: 'enc',
    alg: alg
  });
};